<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.ts'
import { getSupabaseClient } from '@/utils/supabase'

const router = useRouter()
const authStore = useAuthStore()

onMounted(async () => {
  const supabase = getSupabaseClient()
  
  // 监听认证状态变化
  supabase.auth.onAuthStateChange(async (event, session) => {
    console.log('[App] 认证状态变化:', event, session?.user?.id)
    
    if (event === 'SIGNED_IN' && session) {
      console.log('[App] 用户登录成功')
      // 加载用户信息
      await authStore.loadUser(session.user.id)
      
      // 如果当前在登录页或首页，跳转到 dashboard
      const currentPath = router.currentRoute.value.path
      if (currentPath === '/' || currentPath === '/login') {
        console.log('[App] 跳转到 dashboard')
        router.push('/dashboard')
      }
    } else if (event === 'SIGNED_OUT') {
      console.log('[App] 用户登出')
      authStore.user = null
    }
  })
  
  // 注意：不在这里调用 checkAuth()，已经在路由守卫中处理
})
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
